import { FormUnit } from '@/components'
import { AssessmentStepKeys } from '@/enums'
import {
  useFormItem,
  useNextDisabled,
  useNextLoading,
  useOnNextClick,
} from '@/providers'
import { useTranslation } from 'react-i18next'
import { useSaveAssessmentStep } from '../helpers'
import { JSX } from 'react'

interface Messages {
  helperText: string
}

const useMessages = (): Messages => {
  const { t } = useTranslation()

  return {
    helperText: t('approxHelperText'),
  }
}

export const ConstructionValueStep = (): JSX.Element => {
  const messages = useMessages()
  const { value } = useFormItem('constructionValue')
  const { save, isLoading } = useSaveAssessmentStep(
    AssessmentStepKeys.constructionDetails,
  )

  useOnNextClick(save)

  useNextDisabled(() => !value && typeof value !== 'number', [value])

  useNextLoading(() => isLoading, [isLoading])

  return (
    <FormUnit
      helperText={messages.helperText}
      name="constructionValue"
      unit="€"
    />
  )
}
